class StatCounter extends HTMLElement {
  constructor() {
    super();
    this.counters = this.querySelectorAll('.stat-counter[data-animate="true"]');
    this.hasAnimated = false;

    if (this.counters.length > 0) {
      this.setupObserver();
    }
  }

  setupObserver() {
    const options = {
      threshold: 0.5,
      rootMargin: "0px",
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.hasAnimated) {
          this.hasAnimated = true;
          this.animateCounters();
        }
      });
    }, options);

    this.observer.observe(this);
  }

  animateCounters() {
    const duration =
      parseInt(this.getAttribute("data-animation-duration")) || 2000;

    this.counters.forEach((counter) => {
      const target = counter.getAttribute("data-target");
      const numericMatch = target.match(/(\d+\.?\d*)/);

      if (!numericMatch) {
        counter.textContent = target;
        return;
      }

      const numericValue = parseFloat(numericMatch[1]);
      const prefix = target.substring(0, numericMatch.index);
      const suffix = target.substring(
        numericMatch.index + numericMatch[1].length
      );
      const hasDecimal = numericMatch[1].includes(".");
      const steps = 60;
      const stepValue = numericValue / steps;
      const stepDuration = duration / steps;

      let current = 0;
      let step = 0;

      const timer = setInterval(() => {
        step++;
        current = Math.min(stepValue * step, numericValue);

        const displayValue = hasDecimal
          ? current.toFixed(1)
          : Math.floor(current);

        counter.textContent = prefix + displayValue + suffix;

        if (step >= steps) {
          clearInterval(timer);
          counter.textContent = target;
        }
      }, stepDuration);
    });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define("stat-counter", StatCounter);
